import { MarketPillVariant } from '@market/web-components/dist/types/utils/pill-variant';
import { MarketPill } from '@squareup/dex-ui-shared-market';
import { assertNever } from '@squareup/dex-utils-shared-assert-never';
import React, { FC } from 'react';

enum BadgeType {
  Beta,
  Deprecated,
  V1,
}

interface BadgeProps {
  readonly className?: string | undefined;
  readonly size?: 'small' | 'medium';
  readonly type: BadgeType;
}

const getPillText = (type: BadgeType): string => {
  switch (type) {
    case BadgeType.Beta:
      return 'Beta';
    case BadgeType.Deprecated:
      return 'Deprecated';
    case BadgeType.V1:
      return 'V1';
    default:
      return assertNever(type);
  }
};

const getPillVariant = (type: BadgeType): MarketPillVariant => {
  switch (type) {
    case BadgeType.Beta:
      return 'beta';
    case BadgeType.Deprecated:
      return 'critical';
    case BadgeType.V1:
      return 'beta';
    default:
      return assertNever(type);
  }
};

const Badge: FC<BadgeProps> = ({ className, size = 'medium', type }) => {
  const text = getPillText(type);
  const variant = getPillVariant(type);

  return (
    <MarketPill
      {...(className ? { className } : null)}
      testId="badge"
      size={size}
      variant={variant}
    >
      {text}
    </MarketPill>
  );
};

export { Badge, BadgeType };
